import classNames from 'classnames';
import { DAYS_OF_WEEK, TimePickerMode } from '~/constants/dateTime';
import { IWeekModalSaveParams } from '~/mobx/modalStore/types';
import WeekModalOpen from '~/view/containers/Modals/WeekModal/components/WeekModalOpen/WeekModalOpen';
import { isNightTime } from '~/view/screens/MarketingScreen/screens/MessageCampaign/CampaignEditScreen/helpers';
import { messageCampaignStore } from '~/view/screens/MarketingScreen/screens/MessageCampaign/CampaignEditScreen/store/messageCampaignStore';
import { PostingTime } from '~/view/screens/MarketingScreen/screens/MessageCampaign/types';

const CampaignTimeScheduled = () => {
  const { form } = messageCampaignStore;

  const changeTime = (params: IWeekModalSaveParams) => {
    messageCampaignStore.changeForm({
      startAt: params.startDate,
      endAt: params.endDate,
      daysOfWeek: params.daysOfWeek,
      settings: params.timeByDays,
    });
  };

  return (
    <WeekModalOpen
      startDate={form.startAt}
      endDate={form.endAt}
      startTime={undefined}
      endTime={undefined}
      onSave={changeTime}
      validateTime={validateScheduledTime}
      messageOnError="marketing_mc_restricted_range_err"
      title="marketing_mc_repeated_calendar_header"
      className={classNames({ 'input-error': false })}
      minimumOneDayInWeek
      timePickerMode={TimePickerMode.DAYTIME}
      daysOfWeek={form.daysOfWeek}
      timeByDays={form.settings}
      hideAdditionalSettings={form.postingType !== PostingTime.SCHEDULED}
    />
  );
};

const validateScheduledTime = (time: Date | undefined): boolean => !isNightTime(time);

export default CampaignTimeScheduled;
